// extracted by mini-css-extract-plugin
export default {"item":"j_Wyg4QrSF","avatar":"EyS43Rtp8A","name":"uO2vCqAsc0"};